export enum BlockItemType {
  Product = 1,
  TherapeuticClass = 2,
}
